import databaseMSGraphs from '@/utils/templates/databaseTemplate/mssql.database.graphs.config.js';
import hardwareMSGraphs from '@/utils/templates/databaseTemplate/mssql.hardware.graphs.config';
import processesMSGraphs from '@/utils/templates/databaseTemplate/mssql.processes.graphs.config';
import metricsMSSQLGraphs from '@/utils/templates/databaseTemplate/mssql.metrics.graphs.config';
import queryPerfomanceMSGraphs from '@/utils/templates/databaseTemplate/mssql.queryPerformance.graphs.config';
import connectionsMSGraphs from '@/utils/templates/databaseTemplate/mssql.connections.graphs.config';
import nodeMSGraphs from '@/utils/templates/databaseTemplate/mssql.node.graphs.config.js';
import nodeESGraphs from '@/utils/templates/databaseTemplate/es.node.graphs.config.js';
import clusterESGraphs from '@/utils/templates/databaseTemplate/es.cluster.graphs.config.js';
import clusterCBGraphs from '@/utils/templates/databaseTemplate/couchbase.cluster.graphs.config';
import nodeCBGraphs from '@/utils/templates/databaseTemplate/couchbase.node.graphs.config';
import queryCBGraphs from '@/utils/templates/databaseTemplate/couchbase.query.graphs.config';
import bucketCBGraphs from '@/utils/templates/databaseTemplate/couchbase.bucket.graphs.config.js';
import hardwarePSGraphs from '@/utils/templates/databaseTemplate/ps.hardware.graphs.config.js';
import hardwareOraGraphs from '@/utils/templates/databaseTemplate/ora.hardware.graphs.cofig.js';
import connectionsPSGraphs from '@/utils/templates/databaseTemplate/ps.connections.graphs.config.js';
import metricsPSGraphs from '@/utils/templates/databaseTemplate/ps.metrics.graphs.config.js';
import hardwareCSGraphs from '@/utils/templates/databaseTemplate/cs.hardware.graphs.config.js';
import connectionsCSGraphs from '@/utils/templates/databaseTemplate/cs.connections.graphs.config';
import metricsCSGraphs from '@/utils/templates/databaseTemplate/cs.metrics.graphs.config';
import metricsORGraphs from '@/utils/templates/databaseTemplate/ora.metrics.graphs.config';
import connectionsORAGraphs from '@/utils/templates/databaseTemplate/ora.connections.graphs.config.js';
import hardwareMYGraphs from '@/utils/templates/databaseTemplate/my.hardware.graphs.config';
import connectionsMYGraphs from '@/utils/templates/databaseTemplate/my.connections.graphs.config';
import metricsMYGraphs from '@/utils/templates/databaseTemplate/my.metrics.graphs.config';
import * as constants from '@/utils/templates/databaseTemplate/database.constants';
import * as types from '@/components/Database/database.types';
import hardwareMONGOGraphs from '@/utils/templates/databaseTemplate/MongoDB/MongoHardware.graphs.config';
import resourceMONGOGraphs from '@/utils/templates/databaseTemplate/MongoDB/MongoResource.graphs.config';
import connectionsMONGOGraphs from '@/utils/templates/databaseTemplate/MongoDB/MongoConnections.graphs.config';
import metricsMONGOGraphs from '@/utils/templates/databaseTemplate/MongoDB/MongoMetrics.graphs.config';
import performanceMONGOGraphs from '@/utils/templates/databaseTemplate/MongoDB/MongoPerformance.graphs.config';

const database = () => ({
  MY: {
    [constants.SUB_TYPES.MY_INSTANCE]: {
      cards: {
        template: hardwareMYGraphs().cardComponents,
      },
      graphs: {
        template: hardwareMYGraphs().lineCharts,
      },
      progressCard: {
        show: true,
      },
      storageCards: {
        template: hardwareMYGraphs().StorageCardComponents,
      },
    },
    [constants.SUB_TYPES.MY_QUERYPERFORMANCE]: {
      count: {
        show: true,
      },
      table: {
        show: true,
        width: '98%',
      },
    },
    [constants.SUB_TYPES.MY_CONNECTIONS]: {
      graphs: {
        template: connectionsMYGraphs().lineCharts,
      },
      table: {
        show: true,
        height: '30rem',
        width: '96.6%',
      },
    },
    [constants.SUB_TYPES.MY_METRICS]: {
      graphs: {
        template: metricsMYGraphs().lineCharts,
      },
    },
  },
  MS: {
    'ms-hardware': {
      cards: {
        template: hardwareMSGraphs().cardComponents,
      },
      graphs: {
        template: hardwareMSGraphs().lineCharts,
      },
    },
    'ms-processes': {
      graphs: {
        template: processesMSGraphs().lineCharts,
      },
    },
    'ms-query-performance': {
      graphs: {
        template: queryPerfomanceMSGraphs().lineCharts,
      },
      table: {
        show: true,
        width: '98%',
      },
      count: {
        show: true,
      },
    },
    'ms-metrics': {
      graphs: {
        template: metricsMSSQLGraphs().lineCharts,
      },
    },
    'ms-connections': {
      graphs: {
        template: connectionsMSGraphs().lineCharts,
      },
      table: {
        show: true,
        width: '98%',
      },
    },
  },
  [types.DatabaseTypes.cb]: {
    [constants.SUB_TYPES.CB_CLUSTER]: {
      cards: {
        template: clusterCBGraphs().cardComponents,
      },
      graphs: {
        template: [clusterCBGraphs().lineCharts],
      },
      progressCard: {
        show: true,
      },
    },
    [constants.SUB_TYPES.CB_NODE]: {
      cards: {
        template: nodeCBGraphs().cardComponents,
      },
      graphs: {
        template: [nodeCBGraphs().lineCharts, nodeCBGraphs().lineCharts2],
      },
      progressCard: {
        show: true,
      },
    },
    [constants.SUB_TYPES.CB_QUERIES]: {
      query: {
        show: true,
      },
      table: {
        show: true,
      },
      graphs: {
        template: [queryCBGraphs().lineCharts],
      },
    },
    [constants.SUB_TYPES.CB_BUCKET]: {
      dropdown: {
        show: true,
      },
      graphs: {
        template: [bucketCBGraphs().lineCharts],
      },
    },
  },
  ES: {
    'es-cluster': {
      dropdown: {
        show: true,
      },
      graphs: {
        template: clusterESGraphs().lineCharts,
      },
    },
    'es-node': {
      dropdown: {
        show: true,
      },
      graphs: {
        template: nodeESGraphs().lineCharts,
      },
    },
  },
  OR: {
    [constants.SUB_TYPES.ORA_INSTANCE]: {
      cards: {
        template: hardwareOraGraphs().cardComponents,
      },
      graphs: {
        template: hardwareOraGraphs().lineCharts,
      },
      progressCard: {
        show: true,
      },
      storageCards: {
        template: hardwareOraGraphs().StorageCardComponents,
      },
    },
    [constants.SUB_TYPES.ORA_QUERYPERFORMANCE]: {
      count: {
        show: true,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.ORA_CONNECTIONS]: {
      graphs: {
        template: connectionsORAGraphs().lineCharts,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.ORA_METRICS]: {
      graphs: {
        template: metricsORGraphs().lineCharts,
      },
    },
  },
  PG: {
    [constants.SUB_TYPES.POS_INSTANCE]: {
      cards: {
        template: hardwarePSGraphs().cardComponents,
      },
      graphs: {
        template: hardwarePSGraphs().lineCharts,
      },
      progressCard: {
        show: true,
      },
      storageCards: {
        template: hardwarePSGraphs().StorageCardComponents,
      },
    },
    [constants.SUB_TYPES.PS_QUERYPERFORMANCE]: {
      count: {
        show: true,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.PS_CONNECTIONS]: {
      graphs: {
        template: connectionsPSGraphs().lineCharts,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.PS_METRICS]: {
      graphs: {
        template: metricsPSGraphs().lineCharts,
      },
    },
  },
  CA: {
    [constants.SUB_TYPES.CAS_INSTANCE]: {
      cards: {
        template: hardwareCSGraphs().cardComponents,
      },
      graphs: {
        template: hardwareCSGraphs().areaCharts,
      },
      progressCard: {
        show: true,
      },
      storageCards: {
        template: hardwareCSGraphs().StorageCardComponents,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.CAS_QUERYPERFORMANCE]: {
      count: {
        show: true,
      },
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.CAS_CONNECTIONS]: {
      graphs: {
        template: connectionsCSGraphs().areaCharts,
      },
      table: {
        show: true,
      },
    },

    [constants.SUB_TYPES.CAS_METRICS]: {
      graphs: {
        template: metricsCSGraphs().areaCharts,
      },
    },
  },
  [types.DatabaseTypes.mg]: {
    [constants.SUB_TYPES.MONGO_HARDWARE]: {
      cards: {
        show: true,
      },
      progressCard: {
        show: true,
      },
      graphs: {
        template: [hardwareMONGOGraphs().lineCharts],
      },
    },
    [constants.SUB_TYPES.MONGO_QUERYPERFORMANCE]: {
      table: {
        show: true,
      },
    },
    [constants.SUB_TYPES.MONGO_RESOURCE]: {
      graphs: {
        template: [
          resourceMONGOGraphs().saturationCharts,
          resourceMONGOGraphs().usageCharts,
        ],
      },
    },
    [constants.SUB_TYPES.MONGO_PERFORMANCE]: {
      graphs: {
        template: [performanceMONGOGraphs().lineCharts],
      },
    },
    [constants.SUB_TYPES.MONGO_CONNECTIONS]: {
      graphs: {
        template: [connectionsMONGOGraphs().lineCharts],
      },
    },
    [constants.SUB_TYPES.MONGO_METRICS]: {
      graphs: {
        template: [metricsMONGOGraphs().lineCharts],
      },
    },
  },
});
export default database;
